import React from "react";
import ServicePage from "./Components/ServiceComponent";
import webDevImage from "../../assets/img/18063.webp";
import backgoundWeb from "../../assets/img/business-5475661_1920.webp";
import {
  FaLaptopCode,
  FaHouseUser,
  FaMedal,
  FaRobot,
  FaLink,
} from "react-icons/fa";
import IntlMessages from "../../intl/IntlMessages";
const styles = {
  descriptionContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  iconContainer: {
    display: "flex",
    alignItems: "center",
  },
  iconText: {
    marginLeft: "0.5rem",
  },
};

const WebDevelopment = () => {
  return (
    <ServicePage
      title={<IntlMessages id="realEstate.activities" />}
      description={
        <div>
          <p>
            <IntlMessages id="realEstate.description" />
          </p>
          <p>
            <IntlMessages id="realEstate.propertyVariety" />
          </p>
          <div style={styles.descriptionContainer}>
            <div style={styles.iconContainer}>
              <FaLaptopCode size={24} />
              <span style={styles.iconText}>
                <IntlMessages id="realEstate.technology" />
              </span>
            </div>
            <div style={styles.iconContainer}>
              <FaHouseUser size={24} />
              <span style={styles.iconText}>
                <IntlMessages id="realEstate.availableProperties" />
              </span>
            </div>
            <div style={styles.iconContainer}>
              <FaMedal size={24} />
              <span style={styles.iconText}>
                <IntlMessages id="realEstate.numberOne" />
              </span>
            </div>
            <div style={styles.iconContainer}>
              <FaRobot size={24} />
              <span style={styles.iconText}>
                <IntlMessages id="realEstate.aiIntegration" />
              </span>
            </div>
            <div style={styles.iconContainer}>
              <FaLink size={24} />
              <span style={styles.iconText}>
                <IntlMessages id="realEstate.socialPlatforms" />
              </span>
            </div>
          </div>
        </div>
      }
      imageUrl={webDevImage}
      altText={<IntlMessages id="realEstate.activities" />}
      heroBackgroundImage={backgoundWeb}
    />
  );
};

export default WebDevelopment;
